export class ChContextRoles {

    /** директор дирекции */
    static DirectionManager = 'bda11182-18bf-4b0d-9d04-3acc9936b50c';

    /** Дополнительный согласующий для договорного документа. */
    static ArContractAdditionalApprover = '10dbcab2-a1ed-475c-875e-19a87df9586f';

    /** Руководитель инициатора для договорного документа. */
    static ArContractInitiatorLeader = '69e4ba9b-04bd-468e-a5ec-38bd0de38f66';

    /** Автор документа */
    static  AuthorId = 'fd655183-a59e-409a-9a9b-1232087b0cb8';

    /**  Подрядчик */
    static  Contractor = 'ae6d3ff6-5c50-424e-94d9-cd573e6bd0c9';

}